import React, { useState } from 'react';
import { Hero } from './components/Hero';
import { StorySection } from './components/StorySection';
import { ScienceSection } from './components/ScienceSection';
import { WhyMethodsFail } from './components/WhyMethodsFail';
import { HowItWorks } from './components/HowItWorks';
import { Contents } from './components/Contents';
import { TestimonialWall } from './components/TestimonialWall';
import { Guarantee } from './components/Guarantee';
import { Closing } from './components/Closing';
import { OfferSection } from './components/OfferSection';
import { Faq } from './components/Faq';
import { FinalPush } from './components/FinalPush';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { SalesPops } from './components/SalesPops';
import { LegalModal } from './components/LegalModal';
import type { LegalDocument } from './data/legal';
export function App() {
  const [legalDoc, setLegalDoc] = useState<LegalDocument | null>(null);
  return <div className="w-full bg-cream font-sans" data-id="element-0" data-mp="3iiweonbohg2p">
      <Hero data-id="element-1" data-mp="3ii4s22026sok" />
      <main data-id="element-2" data-mp="3mlj6wpc9h30f">
        <StorySection data-id="element-3" data-mp="3ml13n8r6loj0" />
        <ScienceSection data-id="element-4" data-mp="3mkhou0wtvg97" />
        <WhyMethodsFail data-id="element-5" data-mp="3mjq3diwy2ywn" />
        <HowItWorks data-id="element-6" data-mp="3rc9du70c5dx8" />
        <Contents data-id="element-7" data-mp="3rbrbcsn2y3gv" />
        <TestimonialWall data-id="element-8" data-mp="3rdar8i4tqci4" />
        <Guarantee data-id="element-9" data-mp="3rd19tixuhdo1" />
        <Closing data-id="element-10" data-mp="3relw6la09qat" />
        <OfferSection data-id="element-11" data-mp="5orv1p50w72" />
        <Faq data-id="element-12" data-mp="4wvhonpuufq" />
        <FinalPush data-id="element-13" data-mp="4n725ibkvc5" />
      </main>
      <Footer onOpenLegal={setLegalDoc} data-id="element-14" data-mp="7sulgbavp5r" />
      <StickyCta data-id="element-15" data-mp="2zlv84y2h77wn" />
      <SalesPops data-id="element-16" data-mp="2zmeo498kfm81" />
      <LegalModal document={legalDoc} onClose={() => setLegalDoc(null)} data-id="element-17" data-mp="2zmwguvw0rib7" />
    </div>;
}